var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},_vm._l((_vm.occurrence),function(n){return _c('v-skeleton-loader',{key:("skeleton-" + n),ref:"skeleton",refInFor:true,staticClass:"mx-auto",attrs:{"type":_vm.type}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }